const shippingMethodMapping = [
  { label: 'Standard', method: 'Ground', name: 'GROUND' },
  { label: '2nd Business Day', method: '2 Day', name: 'TWODAY' },
  { label: 'Next Business Day', method: 'Overnight', name: 'OVERNIGHT' },
]

export default shippingMethodMapping
